import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { getAllBrandsLink } from "@faire/retailer-visitor-shared/consts/allBrandsLinks";
import { popSignUp, SignUpElement, SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackSignupModalOpenCatnavFaqCtaClick } from "@faire/web-api--source/events/signup/click/modalOpenCatnavFaqCta";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/category/c1CategoryUrlId";
import { path as c2CategoryPath } from "@faire/web-api--source/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import React from "react";
var getCtaPath = function(c1UrlId, c2UrlId) {
    if (!c1UrlId) {
        return getAllBrandsLink();
    }
    if (!c2UrlId) {
        return c1CategoryPath(c1UrlId);
    }
    return c2CategoryPath(c1UrlId, c2UrlId);
};
var getC2LinkFromIUrlIds = function(c1UrlId, c2UrlId) {
    return function getC2LinkFromIUrlIds(chunks) {
        return /*#__PURE__*/ _jsx(Button, {
            variant: "tertiary",
            linkTo: getCtaPath(c1UrlId, c2UrlId),
            children: chunks
        });
    };
};
var getSignUpLink = function(history, chunks, sourceId) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        onClick: function() {
            return popSignUp(history, SignUpType.GENERIC, trackSignupModalOpenCatnavFaqCtaClick, {
                element: SignUpElement.BELOW_FOLD,
                sourceId: "category_page_c1_answer_content_".concat(sourceId)
            });
        },
        children: chunks
    });
};
// All StrictLocalMsg below have been explicitly discussed offline regarding the usage of the placeholders and their
// usage in translation will be checked thoroughly
export var getAnswer1 = function(history, c1, c2) {
    if (!c2) {
        return null;
    }
    // since we do not support dynamic length lists for translations, we are enumerating a separate localized message for
    // each variation in length of the list of c2 links (length of 1 to 5)
    switch(c2.length){
        case 1:
            var _c2_, _c2_1;
            return /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "kqztjR",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "On Faire, there's a variety of products in "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " available for purchase at wholesale prices for your store. Some of the top-selling "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " products on Faire include: "
                        },
                        {
                            type: 8,
                            value: "C2FirstLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FirstLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and more. "
                        },
                        {
                            type: 8,
                            value: "StartShoppingLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Start shopping today"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                        categoryName: c1.name,
                        c2FirstLinkName: (_c2_ = c2[0]) === null || _c2_ === void 0 ? void 0 : _c2_.name
                    })), {
                        C2FirstLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_1 = c2[0]) === null || _c2_1 === void 0 ? void 0 : _c2_1.url_id),
                        StartShoppingLinkFormatting: function(chunks) {
                            var _c1_name;
                            return getSignUpLink(history, chunks, (_c1_name = c1.name) !== null && _c1_name !== void 0 ? _c1_name : "");
                        }
                    })
                })
            });
        case 2:
            var _c2_2, _c2_3, _c2_4, _c2_5;
            return /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "ODpOwP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "On Faire, there's a variety of products in "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " available for purchase at wholesale prices for your store. Some of the top-selling "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " products on Faire include: "
                        },
                        {
                            type: 8,
                            value: "C2FirstLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FirstLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2SecondLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2SecondLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and more. "
                        },
                        {
                            type: 8,
                            value: "StartShoppingLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Start shopping today"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                        categoryName: c1.name,
                        c2FirstLinkName: (_c2_2 = c2[0]) === null || _c2_2 === void 0 ? void 0 : _c2_2.name,
                        c2SecondLinkName: (_c2_3 = c2[1]) === null || _c2_3 === void 0 ? void 0 : _c2_3.name
                    })), {
                        C2FirstLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_4 = c2[0]) === null || _c2_4 === void 0 ? void 0 : _c2_4.url_id),
                        C2SecondLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_5 = c2[1]) === null || _c2_5 === void 0 ? void 0 : _c2_5.url_id),
                        StartShoppingLinkFormatting: function(chunks) {
                            var _c1_name;
                            return getSignUpLink(history, chunks, (_c1_name = c1.name) !== null && _c1_name !== void 0 ? _c1_name : "");
                        }
                    })
                })
            });
        case 3:
            var _c2_6, _c2_7, _c2_8, _c2_9, _c2_10, _c2_11;
            return /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "C23kua",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "On Faire, there's a variety of products in "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " available for purchase at wholesale prices for your store. Some of the top-selling "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " products on Faire include: "
                        },
                        {
                            type: 8,
                            value: "C2FirstLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FirstLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2SecondLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2SecondLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2ThirdLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2ThirdLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and more. "
                        },
                        {
                            type: 8,
                            value: "StartShoppingLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Start shopping today"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                        categoryName: c1.name,
                        c2FirstLinkName: (_c2_6 = c2[0]) === null || _c2_6 === void 0 ? void 0 : _c2_6.name,
                        c2SecondLinkName: (_c2_7 = c2[1]) === null || _c2_7 === void 0 ? void 0 : _c2_7.name,
                        c2ThirdLinkName: (_c2_8 = c2[2]) === null || _c2_8 === void 0 ? void 0 : _c2_8.name
                    })), {
                        C2FirstLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_9 = c2[0]) === null || _c2_9 === void 0 ? void 0 : _c2_9.url_id),
                        C2SecondLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_10 = c2[1]) === null || _c2_10 === void 0 ? void 0 : _c2_10.url_id),
                        C2ThirdLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_11 = c2[2]) === null || _c2_11 === void 0 ? void 0 : _c2_11.url_id),
                        StartShoppingLinkFormatting: function(chunks) {
                            var _c1_name;
                            return getSignUpLink(history, chunks, (_c1_name = c1.name) !== null && _c1_name !== void 0 ? _c1_name : "");
                        }
                    })
                })
            });
        case 4:
            var _c2_12, _c2_13, _c2_14, _c2_15, _c2_16, _c2_17, _c2_18, _c2_19;
            return /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "1PBac9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "On Faire, there's a variety of products in "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " available for purchase at wholesale prices for your store. Some of the top-selling "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " products on Faire include: "
                        },
                        {
                            type: 8,
                            value: "C2FirstLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FirstLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2SecondLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2SecondLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2ThirdLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2ThirdLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2FourthLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FourthLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and more. "
                        },
                        {
                            type: 8,
                            value: "StartShoppingLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Start shopping today"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                        categoryName: c1.name,
                        c2FirstLinkName: (_c2_12 = c2[0]) === null || _c2_12 === void 0 ? void 0 : _c2_12.name,
                        c2SecondLinkName: (_c2_13 = c2[1]) === null || _c2_13 === void 0 ? void 0 : _c2_13.name,
                        c2ThirdLinkName: (_c2_14 = c2[2]) === null || _c2_14 === void 0 ? void 0 : _c2_14.name,
                        c2FourthLinkName: (_c2_15 = c2[3]) === null || _c2_15 === void 0 ? void 0 : _c2_15.name
                    })), {
                        C2FirstLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_16 = c2[0]) === null || _c2_16 === void 0 ? void 0 : _c2_16.url_id),
                        C2SecondLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_17 = c2[1]) === null || _c2_17 === void 0 ? void 0 : _c2_17.url_id),
                        C2ThirdLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_18 = c2[2]) === null || _c2_18 === void 0 ? void 0 : _c2_18.url_id),
                        C2FourthLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_19 = c2[3]) === null || _c2_19 === void 0 ? void 0 : _c2_19.url_id),
                        StartShoppingLinkFormatting: function(chunks) {
                            var _c1_name;
                            return getSignUpLink(history, chunks, (_c1_name = c1.name) !== null && _c1_name !== void 0 ? _c1_name : "");
                        }
                    })
                })
            });
        case 5:
            var _c2_20, _c2_21, _c2_22, _c2_23, _c2_24, _c2_25, _c2_26, _c2_27, _c2_28, _c2_29;
            return /*#__PURE__*/ _jsx(Typography, {
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "mgGDjS",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "On Faire, there's a variety of products in "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " available for purchase at wholesale prices for your store. Some of the top-selling "
                        },
                        {
                            type: 1,
                            value: "categoryName"
                        },
                        {
                            type: 0,
                            value: " products on Faire include: "
                        },
                        {
                            type: 8,
                            value: "C2FirstLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FirstLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2SecondLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2SecondLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2ThirdLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2ThirdLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2FourthLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FourthLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", "
                        },
                        {
                            type: 8,
                            value: "C2FifthLinkFormatting",
                            children: [
                                {
                                    type: 1,
                                    value: "c2FifthLinkName"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: ", and more. "
                        },
                        {
                            type: 8,
                            value: "StartShoppingLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Start shopping today"
                                }
                            ]
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ],
                    values: _object_spread_props(_object_spread({}, DEPRECATED_backwardsCompatibleValues({
                        categoryName: c1.name,
                        c2FirstLinkName: (_c2_20 = c2[0]) === null || _c2_20 === void 0 ? void 0 : _c2_20.name,
                        c2SecondLinkName: (_c2_21 = c2[1]) === null || _c2_21 === void 0 ? void 0 : _c2_21.name,
                        c2ThirdLinkName: (_c2_22 = c2[2]) === null || _c2_22 === void 0 ? void 0 : _c2_22.name,
                        c2FourthLinkName: (_c2_23 = c2[3]) === null || _c2_23 === void 0 ? void 0 : _c2_23.name,
                        c2FifthLinkName: (_c2_24 = c2[4]) === null || _c2_24 === void 0 ? void 0 : _c2_24.name
                    })), {
                        C2FirstLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_25 = c2[0]) === null || _c2_25 === void 0 ? void 0 : _c2_25.url_id),
                        C2SecondLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_26 = c2[1]) === null || _c2_26 === void 0 ? void 0 : _c2_26.url_id),
                        C2ThirdLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_27 = c2[2]) === null || _c2_27 === void 0 ? void 0 : _c2_27.url_id),
                        C2FourthLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_28 = c2[3]) === null || _c2_28 === void 0 ? void 0 : _c2_28.url_id),
                        C2FifthLinkFormatting: getC2LinkFromIUrlIds(c1.url_id, (_c2_29 = c2[4]) === null || _c2_29 === void 0 ? void 0 : _c2_29.url_id),
                        StartShoppingLinkFormatting: function(chunks) {
                            var _c1_name;
                            return getSignUpLink(history, chunks, (_c1_name = c1.name) !== null && _c1_name !== void 0 ? _c1_name : "");
                        }
                    })
                })
            });
        default:
            return null;
    }
};
